<template>
  <div class="select-department-tree">
    <el-select
      v-model="selectVal"
      placeholder="请选择"
      filterable
      :multiple="multiple"
      :filter-method="selectTreeList"
      @change="selectChange"
    >
      <el-option
        :value="treeDataValue"
        class="selectTree"
        style="height: auto"
      >
        <el-tree
          ref="tree"
          node-key="id"
          :filter-node-method="filterNode"
          :data="list"
          :props="defaultProps"
          show-checkbox
          check-strictly
          :highlight-current="true"
          :expand-on-click-node="false"
          @check-change="handleNodeCheck"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="data.children" class="iconfont" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span v-if="!data.children&&!data.image" class="children-img" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span>{{ node.label}}</span>          
          </span>
        </el-tree>
      </el-option>
    </el-select>
    
  </div>
</template>

<script>
export default {
  props: {
    departmentId: {
      type: Array,
    },
    departmentList: {
      type: Array
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectVal: '',
      treeDataValue: '',
      defaultProps: {
        children: "children",
        label: "label"
      },
      id: this.departmentId,
      list: this.departmentList
    }
  },

  created() {
      let list = this.departmentList
      list.map(i => {
        this.getLeafKeys(i)
      })
      this.list = list

  },
  mounted() {
    this.$bus.on('init', v => {
      let list = this.departmentList
      list.map(i => {
        this.getLeafKeys(i)
      })
      this.list = list
    })
    this.$bus.on('getFepartmentId', v => {
      /* select 回填显示 */
      this.$nextTick(() => {
        this.treeDataValue = v
        let arrLable = []
        v.map(i => {
          arrLable.push(i.label)
        })
        this.selectVal = arrLable
        if (this.$refs.tree != undefined) {
          this.$refs.tree.setCheckedNodes(v);
        }
      })
    })

  },

  methods: {
    selectTreeList(val) {
      this.$refs.tree.filter(val);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },

    selectChange(e) {
      let arrNew = []
      let dateLength = this.treeDataValue.length
      let eleng = e.length
      for(let i =0 ; i < dateLength; i++) {
        for(let j=0; j<eleng; j++) {
          if(e[j] === this.treeDataValue[i].label) {
            arrNew.push(this.treeDataValue[i])
          }
        }
      }
      this.$refs.tree.setCheckedNodes(arrNew);
      this.$emit("selectTreeNodeList",arrNew)
    },

    /* 
      通过递归的形式，获取最后一级的id，
     */
    getLeafKeys(node) {
      /* 
        如果当前 node 节点不包含 children 属性，
        则是三级节点
       */
      if (node.level != 3) {
        /* 除了最后一级所有节点disabled为true */
        node.disabled = true;
      }
      node.children.forEach(item => this.getLeafKeys(item));
    },

    handleNodeCheck() {
      let res = this.$refs.tree.getCheckedNodes(true, true);
      let arr = []
      let arrLable = []
      res.map(i => {
        arr.push(i)
        arrLable.push(i.label)
      })
      this.selectVal = arrLable
      this.treeDataValue = arr
      this.$emit("selectTreeNodeList",this.treeDataValue)
    },
  }
}
</script>

<style lang='scss'>
.selectTree {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner{
      display: inline-block;
    }
    .el-checkbox.is-disabled .el-checkbox__inner{
      display: none;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
    }
  }
}
.selectTree.hover, .selectTree:hover {
  background: transparent;
}
.selectTree.el-select-dropdown__item {
  padding: 0px;
  margin: 0px 20px;
}
.select-department-tree {
  .el-tree-node__content {
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
  }
}
</style>